import { useSelector } from 'react-redux';

import AcademyMenu from '../AcademyMenu/AcademyMenu';

import classes from './HeaderBanner.module.css';

const url = window.location.pathname.split('/');

const HeaderBanner = () => {
  const dataAcademy = useSelector(state => state.academyInfo);

  return (
    dataAcademy.showBanner && (
      <>
        <figure className={classes.headerBannerMovil}>
          <img
            className={classes.img}
            src={dataAcademy.data.headerMobileImage}
          />
        </figure>
        <figure className={classes.headerBannerDesktop}>
          <img
            className={classes.img}
            src={dataAcademy.data.headerImage}
          />
        </figure>
        {dataAcademy.menu.length > 0 && url[2] !== 'course' && (
          <AcademyMenu menu={dataAcademy.menu} />
        )}
      </>
    )
  );
};

export default HeaderBanner;
